import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=a67b1f46&scoped=true&"
import script from "./ButtonGroup.vue?vue&type=script&lang=js&"
export * from "./ButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=a67b1f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67b1f46",
  null
  
)

export default component.exports